<script setup>
  import { computed, onMounted, ref, watch } from 'vue'
  import PublicationTypeValues from '~/values/PublicationTypeValues.js'
  import { getCategoriesByPublicationType, getPublicationsByCategory, mergeObjectByType, } from '~/utils/functions'

  const props = defineProps({
    type: {
      required: true,
      type: String,
    },
  })

  const $route = useRoute()
  const { $axios } = useNuxtApp()
  const categories = useState('categories')
  const fetchPublications = ref(true)
  const typeLabel = PublicationTypeValues.get(props.type).label_plural
  const selectedCategory = ref()
  const publications = ref([])
  const filteredPublications = ref([])
  const entities = computed(() => {
    const typeMapping = {
      sport: 'artists',
      event: 'artists',
      travel: 'producers',
      entertainment: 'producers',
      theater: 'producers',
    }
    const key = typeMapping[props.type]
    if (key) {
      return [
        ...mergeObjectByType(publications.value, key, `${key.slice(0, -1)}_id`),
      ]
    }
    return []
  })

  function getPublicationByType() {
    return $axios
      .get('publication', { params: { origin: 'feed', type: props.type } })
      .then((response) => {
        fetchPublications.value = false
        publications.value = response.data.data
        filteredPublications.value = response.data.data
      })
      .catch((error) => {
        fetchPublications.value = false
        console.error(error)
      })
  }

  const filteredCategories = computed(
    () =>
      getCategoriesByPublicationType(
        publications.value,
        categories.value,
        props.type
      ) ?? []
  )

  const orderedPublications = computed(() => {
    const publicationsToSort = selectedCategory.value
      ? [...filteredPublications.value]
      : [...publications.value]

    return publicationsToSort.sort((a, b) => {
      const isAFeatured = a.countries.some((country) => country?.is_featured)
      const isBFeatured = b.countries.some((country) => country?.is_featured)

      return Number(isBFeatured) - Number(isAFeatured)
    })
  })

  watch(
    [$route, () => publications.value],
    ([route, publicationsValue]) => {
      if (categories.value?.length) {
        const categorySlug = route.query.category
        selectedCategory.value = categorySlug

        const categoryToFilter = categories.value.find(
          ({ slug }) => slug === categorySlug
        )

        filteredPublications.value = categoryToFilter
          ? getPublicationsByCategory(publicationsValue, categoryToFilter.id)
          : publicationsValue
      }
    },
    { immediate: true }
  )

  onMounted(() => {
    getPublicationByType()
  })
</script>

<template>
  <div class="main-container mt-4">
    <div class="text-center space-y-2">
      <div class="text-5xl font-bold">{{ typeLabel }}</div>
      <div class="text-2xl text-gray-400">
        Elige un evento que se adapte a tu experiencia
      </div>
    </div>

    <ProfileItemCarousel
      :publications="orderedPublications"
      :entity="entities"
      :categories="filteredCategories"
      :isLoading="fetchPublications"
    />

    <div class="publication-item-container">
      <template v-if="fetchPublications">
        <PublicationItem
          v-for="skPublication in 3"
          :key="skPublication"
          isLoading
        />
      </template>
      <template v-else>
        <PublicationItem
          v-for="publication in orderedPublications"
          :publication="publication"
        />
      </template>
    </div>
  </div>
</template>
